import { createContext } from 'react';
import EditCommerceContext from 'types/contexts/EditCommerceContext';

export default createContext({} as EditCommerceContext);
